
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/csr/society/rural",
      function () {
        return require("private-next-pages/csr/society/rural.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/csr/society/rural"])
      });
    }
  